import React, { useEffect } from 'react';

import { Alert } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

const PageNotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/');
  }, []);

  return (
    <div>
      <Alert color="danger">Stránka neexistuje.</Alert>
    </div>
  );
};

export default PageNotFound;
